import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8 md:p-12">
        {/* Header */}
        <div className="mb-10 pb-8 border-b-2 border-gray-200">
          <h1 className="text-h2 text-dark4 mb-4">Privacy Policy</h1>
          <p className="text-bodyMR text-dark5">
            Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>

        {/* Content */}
        <div className="space-y-8">
          {/* Introduction */}
          <section className="space-y-4">
            <p className="text-bodyLR text-dark5 leading-relaxed">
              At Testament.digital, we are committed to protecting your privacy. This Privacy Policy explains 
              how we collect, use, disclose, and safeguard your information when you use our platform and services.
            </p>
          </section>

          {/* Section 1 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">1. Information We Collect</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We collect information that you provide directly to us, including personal information such as 
              your name, email address, and any other information you choose to provide when creating an account 
              or using our services.
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li className="text-bodyMR text-dark5">Account information (name, email address, password)</li>
              <li className="text-bodyMR text-dark5">Profile information you choose to provide</li>
              <li className="text-bodyMR text-dark5">Content you upload or create on our platform</li>
            </ul>
          </section>

          {/* Section 2 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">2. How We Use Your Information</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We use the information we collect to provide, maintain, and improve our services, to process 
              your transactions, and to communicate with you about our services.
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li className="text-bodyMR text-dark5">To provide and maintain our services</li>
              <li className="text-bodyMR text-dark5">To process your transactions and send you related information</li>
              <li className="text-bodyMR text-dark5">To send you technical notices and support messages</li>
              <li className="text-bodyMR text-dark5">To respond to your comments and questions</li>
            </ul>
          </section>

          {/* Section 3 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">3. Information Sharing and Disclosure</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We do not sell, trade, or rent your personal information to third parties. We may share your 
              information only in the following circumstances:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li className="text-bodyMR text-dark5">With your consent</li>
              <li className="text-bodyMR text-dark5">To comply with legal obligations</li>
              <li className="text-bodyMR text-dark5">To protect and defend our rights or property</li>
              <li className="text-bodyMR text-dark5">With service providers who assist us in operating our platform</li>
            </ul>
          </section>

          {/* Section 4 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">4. Data Security</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We implement appropriate technical and organizational security measures to protect your personal 
              information against unauthorized access, alteration, disclosure, or destruction. However, no 
              method of transmission over the Internet or electronic storage is 100% secure.
            </p>
          </section>

          {/* Section 5 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">5. Your Rights</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              You have the right to access, update, or delete your personal information at any time. You can 
              also opt-out of certain communications from us. To exercise these rights, please contact us 
              using the information provided below.
            </p>
          </section>

          {/* Section 6 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">6. Changes to This Privacy Policy</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any changes by 
              posting the new Privacy Policy on this page and updating the "Last updated" date. You are 
              advised to review this Privacy Policy periodically for any changes.
            </p>
          </section>

          {/* Contact Section */}
          <section className="mt-12 pt-8 border-t-2 border-gray-200">
            <h2 className="text-h5 text-dark4 font-semibold mb-4">Contact Us</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us at{" "}
              <a href="mailto:privacy@testament.digital" className="text-primary hover:underline">
                privacy@testament.digital
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
